import { getPassedTime } from "../../../js/modules/functions";
import { useActivityFeed } from "./activity-feed";
import { ActivityHubAvatar } from "./activity-hub-avatar";

function getActivityTextAction({ activityType, targetMember }) {
  const {
    liked,
    likedYourCollection,
    startedFollowing,
    startedFollowingYou,
    sharedCollection,
  } = useActivityFeed();
  switch (activityType) {
    case 1:
      return liked;
    case 2:
      return targetMember?.isCurrentUser ? likedYourCollection : liked;
    case 3:
      return targetMember && !targetMember.isCurrentUser
        ? startedFollowing
        : startedFollowingYou;
    case 4:
      return sharedCollection;
    default:
      return "";
  }
}

function ActivityGroupItemStatusTextTarget({
  activityType,
  colours,
  targetMember,
  collection,
}) {
  const { multipleColours, colourCollection } = useActivityFeed();

  switch (activityType) {
    case 1:
      if (colours.length > 1) {
        return <span>{multipleColours}</span>;
      } else if (colours[0]?.url) {
        return (
          <a
            class="activity-feed-group-item__collection-name"
            href={colours[0].url}
          >
            {colours[0].name}
          </a>
        );
      } else {
        return <span>{colours[0]?.name}</span>;
      }
    case 2:
      if (targetMember?.isCurrentUser) {
        return (
          <a
            className="activity-feed-group-item__collection-name"
            href={collection.collectionUrl}
          >
            {collection.name}
          </a>
        );
      } else if (targetMember) {
        return (
          <>
            <a
              className="activity-feed-group-item__collection-name"
              href={targetMember.profileUrl}
            >
              @{targetMember.name ?? targetMember.umbracoUserId}
            </a>
            {colourCollection}{" "}
            <a
              className="activity-feed-group-item__collection-name"
              href={collection.collectionUrl}
            >
              {collection.name}
            </a>
          </>
        );
      } else {
        return (
          <a
            className="activity-feed-group-item__collection-name"
            href={collection.collectionUrl}
          >
            {collection.name}
          </a>
        );
      }
    case 3:
      if (targetMember && !targetMember.isCurrentUser) {
        return (
          <a
            className="activity-feed-group-item__collection-name"
            href={targetMember.profileUrl}
          >
            @{targetMember.name ?? targetMember.umbracoUserId}
          </a>
        );
      }
      break;
    case 4:
      return (
        <a
          className="activity-feed-group-item__collection-name"
          href={collection.collectionUrl}
        >
          {collection.name}
        </a>
      );
  }
}

function ActivityGroupItemStatusText({
  actor,
  colours,
  targetMember,
  collection,
  activityType,
}) {
  const action = getActivityTextAction({ activityType, targetMember });

  return (
    <p className="activity-feed-group-item__text">
      <a
        href={actor.profileUrl}
        className="activity-feed-group-item__user-name"
      >
        @{actor.name ?? actor.umbracoUserId}
      </a>{" "}
      {action}{" "}
      <ActivityGroupItemStatusTextTarget
        activityType={activityType}
        colours={colours}
        targetMember={targetMember}
        collection={collection}
      />
    </p>
  );
}

export const ActivityGroupItemStatus = ({ activityData }) => {
  const { justNow, minsAgo, hoursAgo, daysAgo } = useActivityFeed();
  const { activityType, actor, timestamp, targetMember, collection, colours } =
    activityData;

  return (
    <>
      <ActivityHubAvatar
        isLiked={[1, 2].includes(activityType)}
        imgUrl={actor.imageUrl}
      />
      <div className="activity-feed-group-item__text-wrapper">
        <ActivityGroupItemStatusText
          actor={actor}
          colours={colours}
          targetMember={targetMember}
          collection={collection}
          activityType={activityType}
        />
        <p className="activity-feed-group-item__time">
          {getPassedTime({
            timestamp,
            justNow,
            minsAgo,
            hoursAgo,
            daysAgo,
          })}
        </p>
      </div>
    </>
  );
};
